function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 1.5,
  cy: 6.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 1.5,
  cy: 11.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 1.5,
  cy: 16.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 6.5,
  cy: 1.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 6.5,
  cy: 11.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 6.5,
  cy: 16.5,
  r: 1.5,
  fill: "#DDDDDD"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/dnd-icon.0f04262f.svg";
export { SvgComponent as ReactComponent };